import React, { lazy, Suspense } from 'react';
import { LoadingSpinner } from './Loading/LoadingSpinner';

// Lazy load the AnimatedTitle component
const AnimatedTitle = lazy(() => import('./AnimatedTitle'));

interface LazyAnimatedTitleProps {
  title: string;
  subtitle: string;
  className?: string;
}

/**
 * Lazy-loaded version of AnimatedTitle with loading fallback
 */
const LazyAnimatedTitle: React.FC<LazyAnimatedTitleProps> = (props) => {
  return (
    <Suspense 
      fallback={
        <div className="animated-title-container">
          <div className="flex flex-col items-center space-y-4">
            <LoadingSpinner size="large" />
            <div className="text-center">
              <h1 className="text-4xl md:text-6xl font-black text-transparent bg-gradient-to-r from-yellow-400 to-green-400 bg-clip-text">
                {props.title}
              </h1>
              <p className="text-lg md:text-xl text-green-100 mt-2">
                {props.subtitle}
              </p>
            </div>
          </div>
        </div>
      }
    >
      <AnimatedTitle {...props} />
    </Suspense>
  );
};

export default LazyAnimatedTitle;